import React from "react";
import { DetailedHTMLProps, FC, SVGProps } from "react";

export const LogoutIcon: FC<
  DetailedHTMLProps<SVGProps<SVGSVGElement>, SVGSVGElement> & {className?: string;}
> = ({className}) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >

    <path
      d="M15.016 7.38948V6.45648C15.016 4.42148 13.366 2.77148 11.331 2.77148H6.45597C4.42197 2.77148 2.77197 4.42148 2.77197 6.45648V17.5865C2.77197 19.6215 4.42197 21.2715 6.45597 21.2715H11.341C13.37 21.2715 15.016 19.6265 15.016 17.5975V16.6545"
      stroke="#200E32"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M21.8096 12.0214H9.76855"
      stroke="#200E32"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.8811 9.10626L21.8091 12.0213L18.8811 14.9373"
      stroke="#200E32"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
